'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attachmentUploadComplete = undefined;

var _reduxActions = require('redux-actions');

var _fileUploadsActionTypes = require('../constants/fileUploadsActionTypes');

var attachmentUploadComplete = exports.attachmentUploadComplete = (0, _reduxActions.createAction)(_fileUploadsActionTypes.ATTACHMENT_UPLOAD_COMPLETE);


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/actions/attachmentUploadComplete.js
// module id = 561
// module chunks = 2 3